module.exports = __webpack_public_path__ + "img/Nejilka_Portrait_Glenford_Nunez.2cbf06ac.2cbf06ac.jpg";